import React from 'react'
import { POPUP_OPEN, ALERT_OPEN, POPUP_CLOSE, AUTH_STUDENT } from 'actions'
import StudentLoginErrorNudge from 'components/student-login-error-nudge'

import { logout as deleteTokens } from './auth'
import { logout as logoutAction } from 'actions/auth'

const INVALID_AUTH_MESSAGE = 'Authentication Invalid'

export function openPopup(
    content,
    style = {},
    onClose = null,
    windowStyle = {}
) {
    return {
        type: POPUP_OPEN,
        payload: {
            content,
            style,
            onClose,
            windowStyle,
        },
    }
}

export function openAlert(content, onClose) {
    return {
        type: ALERT_OPEN,
        payload: {
            content,
            onClose,
        },
    }
}

/**
 * Called when redux action that call API throw error
 * @param {object} payload - Http Error payload
 * @param {string} type - Action type
 */
export function alertError(payload, type) {
    switch (payload.status) {
        case 401: {
            const content = <StudentLoginErrorNudge />
            if (payload.message === INVALID_AUTH_MESSAGE) {
                deleteTokens()
                logoutAction()
                return openAlert('Please log in to BookNook', () => {
                    window.location.reload()
                })
            } else if (type === AUTH_STUDENT) {
                return openPopup(content)
            } else {
                const message = `Please confirm that you have entered the correct credentials.  
                For tutors this is an email address and password.`
                return openAlert(message)
            }
        }
        case 400: {
            const message = (
                <div>
                    The following errors occurred:
                    <br />
                    {payload.validationErrors.map(e => (
                        <div key={e.field} className="validation-error">
                            {e.field} {e.message}
                        </div>
                    ))}
                </div>
            )
            return openAlert(message)
        }
        case 500: {
            const message = `An unexpected error has occurred with the BookNook servers.  
            If this continues please contact technical support.`
            return openAlert(message)
        }
        default:
            const message = payload.message
            return openAlert(message)
    }
}

export function closePopup() {
    return {
        type: POPUP_CLOSE,
    }
}
